import React from 'react'
import { withRouter } from 'react-router-dom'
import { Subscribe } from 'unstated'
import CourseStore from '../../../Store/CourseStore'
import CourseContent from '../../../../../Modules/CourseContent/CourseContent'

const LessonPlan = () => (
  <Subscribe to={[CourseStore]}>
    {({ state }) => (
      <div className='lessonPlan'>
        <CourseContent
          chapters={state.chapters}
          id={state.id}
          userType={state.userType}
          enrollmentID={
            state.enrollments && state.enrollments.length
              ? state.enrollments[0].id
              : null
          }
        />
      </div>
    )}
  </Subscribe>
)

export default withRouter(LessonPlan)
